/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import CheckboxPanelSection from "../../../molecules/finder/CheckboxPanelSection";
import {connect} from "react-redux";
import {getTagMap} from "../../../../selectors/tags";
import {closeFinderPanel, toggleTag} from "../../../../actions/finder";
import {SearchTypeAhead} from "../../../molecules/finder/SearchTypeAhead";
import {ShowHide} from "../../../atoms/layout/ShowHide";


class SidepanelCheckboxesPanel extends React.Component {

    static propTypes = {
        filter: PropTypes.any,
        sections: PropTypes.array,
        selected: PropTypes.array,

        closeFinderPanel: PropTypes.func,
        toggleTag: PropTypes.func,
    };

    state = {
        search: ''
    };

    constructor(props) {
        super(props);

        this.onSearchedTagSelect = this.onSearchedTagSelect.bind(this);
        this.onTagSelect = this.onTagSelect.bind(this);
        this.allTagsSelector = createSelector(
            (props) => props.sections,
            (sections) => [].concat(...sections.map(section => [].concat(...section.tags.map(tags => tags.tag.children))))
        );
    }

    onSearchedTagSelect = (item) => {
        if (item && item.id) {
            this.props.toggleTag({ filterIndex: this.props.filter.index, tag: item.id });
            this.props.closeFinderPanel();
        }
    };

    onTagSelect = (tagId) => {
        this.props.toggleTag({ filterIndex: this.props.filter.index, tag: tagId });
    };

    render() {
        const {sections, filter, selected} = this.props;

        if (!filter || !sections) {
            return null;
        }

        return <React.Fragment>

            <ShowHide show={!filter.hideSearchbox}>
                <SearchTypeAhead items={this.allTagsSelector(this.props)}
                                 placeholder={filter.searchPlaceholder}
                                 filterBy={['title']}
                                 disableFreeText
                                 emptyLabel={this.props.resource && this.props.resource.noResultsMessage}
                                 onSelect={this.onSearchedTagSelect}/>
            </ShowHide>

            <hr className={`p-filter-container__aside-panel-body-separator ${filter.hideSearchbox ? 'desktop-visible' : ''}`} />

            { sections.map(section => <CheckboxPanelSection key={section.title} filterIndex={filter.index}
                                                            title={section.title} selected={selected}
                                                            toggleTag={this.onTagSelect} tags={section.tags}/>)}
        </React.Fragment>
    }

}

const mapStateToProps = () => {
    const tagSelector = createSelector(
        (state) => getTagMap(state),
        (state, ownProps) => ownProps.filter,
        (tags, filter) => filter.filterGroups.map(group => ({
            title: group.title,
            tags: group.tags.map(t => ({ ...t, tag: tags[t.tag]}))
        }))
    );

    return (state, ownProps) => {
        return {
            sections: tagSelector(state, ownProps)
        }
    }

};

export default connect(mapStateToProps, { closeFinderPanel, toggleTag })(SidepanelCheckboxesPanel);
